import { Component, OnInit } from '@angular/core';
import { JobSpecificationService } from 'src/app/Services/admin-rights/job-specification.service';
import { MatSnackBarComponent } from '../mat-snack-bar/mat-snack-bar.component';
import { JobItemList } from 'src/app/Models/Admin/jobitemspecification';
import { Router } from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-job-specification',
  templateUrl: './job-specification.component.html',
  styleUrls: ['./job-specification.component.css']
})
export class JobSpecificationComponent implements OnInit {
  jobList: JobItemList[];
  loader: string = 'none';
  displayAddJob: string = 'none';
  jobItem: string = '';
  constructor(private snackBar: MatSnackBarComponent, private router: Router, private jobSpecificationService: JobSpecificationService,private toastr: ToastrService) {
    this.getJobList();
  }

  ngOnInit() {
    if (sessionStorage.tabID == undefined) {
      this.router.navigate(['/MCMaterial/Login']);
    }
  }

  getJobList() {
    this.loader = 'block';
    this.jobSpecificationService.getJobList()
      .subscribe((resdata: any) => {
        if (resdata.status == true) {
          this.jobList = resdata.data;
          this.loader = 'none';
        }
        else {
          this.toastr.error(resdata.msg);
          this.loader = 'none';
        }
      })
  }

  addJob() {
    this.displayAddJob = 'block';
  }

  closeAddJob() {
    this.displayAddJob = "none";
  }

  addJobitem() {
    if (this.jobItem == "" || this.jobItem == null) {
      this.toastr.error("Empty input Feild");
      this.jobItem = "";
    }
    else {
      var addJobItem = {
        jobType: this.jobItem,
        isActive: true
      }
      this.jobList.push(addJobItem);
      this.jobItem = "";
      this.displayAddJob = "none"
    }
  }

  updateJobItemSpecification() {
    this.loader = 'block';
    let updateJobItemList: JobItemList[] = [];
    this.jobList.forEach(function (detail) {
      let addJobItem = {
        jobType: detail.jobType,
        isActive: detail.isActive
      };
      updateJobItemList.push(addJobItem)

    });
    this.jobSpecificationService.updateJobConfiguration(updateJobItemList)
      .subscribe((resdata: any) => {
        if (resdata.status == true) {
          this.toastr.success('Job Item List have been Configured.');
          this.loader = 'none';
          this.getJobList();
        }
        else {
          this.toastr.error(resdata.msg);
          this.loader = 'none';
        }
      });
  }

}
